class AccountLogsDatatable {
    constructor(){
        let organizationID = new URLSearchParams(window.location.search).get('organizationID')
        this.datatable = this.init('#account-logs-datatable', organizationID);
        this.initFilter();
    }
    init(el, organizationID){
        const datatable =  $(el).DataTable({
            searchDelay: 400,
            processing: true,
            serverSide: true,
            stateSave: false,
            info: true,
            paging: true,
            order: [[2, 'desc']],
            searchCols: [
                null,
                null,
                { "search": (moment().startOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")+' - '+moment().endOf('isoWeek').format("YYYY-MM-DD hh:mm:ss")), "regex": false }
            ],
            ajax: {
                url: '/security-settings/?do=getAccountLogs',
                type: 'POST',
                data: {
                    organizationID: organizationID,
                }
            },
            language: {
                emptyTable: "No data found"
            },
            dom:
                "<'table-responsive'tr>" +
                "<'row'" +
                "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'li>" +
                "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'p>" +
                ">",
            drawCallback: function(settings) {
                // Remove all visible popovers after datatable draw
                document.querySelectorAll('.popover.fade.show').forEach(function (el) {
                    el.remove();
                });
                // Init all popovers after datatable draw
                const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
                popoverTriggerList.map(function (popoverTriggerEl) {
                    new bootstrap.Popover(popoverTriggerEl);
                });
                // init page length select
                $('select[name=account-logs-datatable_length]').select2({minimumResultsForSearch: -1});
            },
            columns: [
                {
                    data: 'uuid',
                    title: 'Team',
                    className: 'min-w-150px',
                    sortable: true,
                    render: function (data, type, row) {
                        if(row['organization']){
                            return '<div class="d-flex" data-kt-element="team">\n' +
                                '       <span class="d-flex flex-center flex-shrink-0 w-40px me-3">\n' +
                                '            <div class="symbol symbol-circle symbol-40px">\n' +
                                '                <div class="symbol-label fw-bold bg-primary text-inverse-primary">'+row['organization']['name'].charAt(0).toUpperCase()+'</div>\n' +
                                '             </div>\n' +
                                '        </span>\n' +
                                '        <span class="d-flex flex-column align-items-start name-product sub-name-product">\n' +
                                '             <a href="'+row['organization']['link']+'"><span class="fs-5 fw-bold text-primary mb-1 text-decoration-underline-ga primary" data-kt-element="title">\n' +
                                '                  '+row['organization']['name']+'\n' +
                                '             </span></a>\n' +
                                '             <span class="fs-7 fw-bold ga-text-primary-500 lh-sm" data-kt-element="desc">\n' +
                                '                  '+row['organization']['product']+'\n' +
                                '             </span>\n' +
                                '          </span>\n' +
                                '    </div>';
                        }

                        return '-';
                    }
                },
                {
                    data: 'ip',
                    title: 'From IP',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span class="text-nowrap">`+row['ip']+`<i class="fa-regular fa-circle-question ms-1 fs-7 cursor-help" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-html="true" data-bs-content="<div class='d-flex align-items-center'><div class='symbol symbol-30px me-3 border ga-border-primary-300 symbol-circle'><div class='symbol-label bg-light-primary border border-2 border-white overflow-hidden'>`+(row[`iso2`] ? `<img src='/media/goodaccess/country-flags/png100px/` + row[`iso2`].toLowerCase() + `.png' class='h-30px' alt='flag'>` : `<i class='fa-solid fa-question fs-1'></i>`)+`</div></div><div class='d-flex justify-content-start flex-column'>`+(row[`country`] ? `<div><span class='fw-bold text-white mb-1 fs-7'>`+row[`country`]+`</span></div>` : ``)+`<span class='fw-semibold d-block fs-8 text-white'>` + row['city'] + `</span></div></div>"></i></span>`;
                    }
                },
                {
                    data: 'date',
                    title: 'Date',
                    className: 'min-w-90px',
                    sortable: true,
                    render: function (data, type, row) {
                        return `<span data-bs-toggle="popover" data-bs-trigger="hover" data-bs-placement="bottom" data-bs-content="${row['timezone']}">${row['date']}</span>`;
                    }
                },
                {
                    data: 'category',
                    title: 'Category',
                    sortable: true,
                    className: 'min-w-80px',
                    render: function (data, type, row) {
                        return row['category'];
                    }
                },
                {
                    data: 'message',
                    title: 'Message',
                    sortable: true,
                    className: 'min-w-200px',
                    render: function (data, type, row) {
                        return row['message'];
                    }
                },
            ]
        }).on('preDraw', function () {
            $('#account-logs-datatable_wrapper').show();
            $('#account-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
        }).on('draw', function () {
            if(datatable.page.info().recordsTotal === 0){
                $('#account-logs-datatable_wrapper').hide();
                $('#account-logs-datatable_no-results').addClass('d-flex flex-center flex-column').removeClass('d-none');
            } else {
                $('#account-logs-datatable_wrapper').show();
                $('#account-logs-datatable_no-results').addClass('d-none').removeClass('d-flex flex-center flex-column');
            }
        });

        // Init and add delay to datatable search
        new DatatableSearchDelay(datatable, '#account_logs_tab [data-kt-docs-table-filter=search]');
        return datatable;
    }
    initFilter(){
        const thisClass = this;
        this.initDateTimePicker();
        this.initFilterSelect2();

        // Apply
        const applyFilterButton = document.querySelector('#account_logs_tab [data-table-filter-action="account-logs-datatable-apply"]');
        if(applyFilterButton) {
            applyFilterButton.addEventListener('click', function () {
                thisClass.applyFilter();
            });
        }

        // Reset
        const resetFilterButton = document.querySelector('#account_logs_tab [data-table-filter-action="account-logs-datatable-reset"]');
        if(resetFilterButton){
            resetFilterButton.addEventListener('click', function () {
                // Reset inputs
                $('[data-table-filter="account-logs-datatable-category"]').val([]).trigger('change');
                $('[data-table-filter="account-logs-datatable-organization"]').val([]).trigger('change')
                // Reset date
                const dateEl = $("[data-table-filter=account-logs-datatable-date]");
                dateEl.data('daterangepicker').setStartDate(moment().startOf('isoWeek'));
                dateEl.data('daterangepicker').setEndDate(moment().endOf('isoWeek'));

                thisClass.applyFilter(true);
            });
        }
    }
    initDateTimePicker(){
        const dateEl = $("#account_logs_tab [data-table-filter=account-logs-datatable-date]");

        let start = moment().startOf('isoWeek');
        let end = moment().endOf('isoWeek');

        function formatDate(start, end) {
            dateEl.html(start.format("MMM D, YYYY") + " - " + end.format("MMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            locale: {
                format: "MMM D, YYYY"
            },
            parentEl: '#accountLogsFilterMenu',
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }
    initFilterSelect2(){
        // Format Member options
        const tagFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            span.innerHTML = item.text;
            return $(span);
        }
        // Format Member results
        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }

            const span = document.createElement('span');
            let template = '';
            template += '<div class="d-flex align-items-center">';
            template += item.element.getAttribute('data-kt-rich-content-avatar');
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 fw-bold lh-1 text-primary">' + item.text +'</span>';
            template += '<span class="fs-8 fw-bold ga-text-primary-500">' + item.element.getAttribute('data-kt-rich-content-subcontent') + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        // Init Select2
        const element = document.querySelector('#account_logs_tab [data-table-filter="account-logs-datatable-organization"]');
        if(element){
            $(element).select2({
                placeholder: "Select an option",
                templateSelection: tagFormat,
                templateResult: optionFormat,
                minimumResultsForSearch: -1,
                dropdownParent: $('#accountLogsFilterMenu'),
                allowClear: true
            });

            // Prevent menu from closing when deselecting an item from select2
            const menuEl = document.querySelector("#accountLogsFilterMenu");
            if (menuEl) {
                const menu = KTMenu.getInstance(menuEl);
                if (menu) {
                    $(element).on('select2:unselect', function (e) {
                        element.setAttribute("data-multiple-unselect", "1");
                    });
                    $(element).on('select2:clear', function (e) {
                        $(element).val([]).trigger("change");
                    });
                    menu.on("kt.menu.dropdown.hide", function(item) {
                        if (element.getAttribute("data-multiple-unselect") === "1") {
                            element.removeAttribute("data-multiple-unselect");
                            return false;
                        }
                    });
                }
            }
        }
    }
    applyFilter(reset = false){
        const thisClass = this;
        let numberOfActiveFilters = 1; // Date is always set
        let numberOfActiveFiltersEl = document.getElementById('accountLogsDatatableNumberOfActiveFilters');
        let date = document.querySelector('#accountLogsDateFilter');

        if(reset){
            this.datatable.columns().search('');
        } else {
            let category = $('#accountLogsFilterMenu [data-table-filter="account-logs-datatable-category"]').select2('data');
            let categoryArr = [];
            for(const i in category){
                if(category[i].id !== ''){
                    categoryArr.push(category[i].id);
                }
            }

            let organizations = $('#accountLogsFilterMenu [data-table-filter="account-logs-datatable-organization"]').select2('data');
            let organizationsArr = [];
            for(const i in organizations){
                if(organizations[i].id !== ''){
                    organizationsArr.push(organizations[i].id);
                }
            }

            thisClass.datatable.column(0).search(JSON.stringify(organizationsArr));
            numberOfActiveFilters += organizationsArr.length;
            thisClass.datatable.column(3).search(JSON.stringify(categoryArr));
            numberOfActiveFilters += categoryArr.length;

            thisClass.datatable.column(2).search(date.value);
        }
        numberOfActiveFiltersEl.innerText = numberOfActiveFilters;
        thisClass.datatable.draw();
    }
}
window.AccountLogsDatatable = AccountLogsDatatable;